module.exports = __webpack_public_path__ + "static/media/another_tab.1471fd69.svg";